import React from 'react';

export const NotFound = () => {
  return(
    <h2>Page not found</h2>
  );
}